import React, { useRef, useState } from 'react';
import { Bot } from 'lucide-react';
import { SyllabusModal } from './SyllabusModal';
import { SYLLABUS } from './data';

export const ConvergeWorkshop = () => {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  return (
    <section id="workshop" className="scroll-mt-20 bg-[#365CFF] text-white border-b-2 border-[#111] relative overflow-hidden" data-testid="workshop-section">
      <div className="absolute inset-0 cv-dots opacity-[0.12] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D7FF38]">[ 02 ] Workshop · Day 01 morning</p>
          <h2 className="cv-display font-extrabold uppercase leading-[0.88] mt-3 text-5xl sm:text-7xl lg:text-[5.5rem] xl:text-8xl break-words" data-testid="workshop-title">AI &amp;<br />Agentic AI</h2>
          <p className="mt-5 cv-display text-xl sm:text-2xl font-bold">From LLM Fundamentals to Building Your First AI Agent</p>
          <p className="mt-5 inline-block bg-[#111] text-[#D7FF38] border-2 border-[#111] px-3 py-2 text-xs sm:text-sm font-bold uppercase tracking-wider" data-testid="workshop-schedule">16 November 2026 | 9:30 AM – 12:30 PM | 3 Hours</p>
          <p className="mt-6 max-w-xl text-sm sm:text-base font-medium leading-relaxed text-white/90">
            A practical introduction to generative AI, large language models, AI agents, tool calling, and intelligent automation. Learn the foundations and explore how AI agents can perform multi-step tasks.
          </p>
          <button ref={btnRef} type="button" onClick={() => setOpen(true)} className="cv-btn mt-8 inline-flex items-center gap-2 bg-[#D7FF38] text-[#111] border-2 border-[#111] shadow-[4px_4px_0_#111] px-6 py-4 text-sm font-extrabold uppercase tracking-wider" data-testid="open-syllabus-btn">
            Explore workshop syllabus ↗
          </button>
        </div>
        <div className="lg:col-span-5">
          <div className="bg-[#F5F3EB] text-[#111] border-2 border-[#111] shadow-[8px_8px_0_#111] rotate-1">
            <div className="flex items-center justify-between px-4 py-3 border-b-2 border-[#111] bg-[#D7FF38]">
              <span className="text-xs font-extrabold uppercase tracking-widest">agent.loop()</span><Bot size={18} />
            </div>
            <ol className="p-4 space-y-2">
              {SYLLABUS.map((m) => (
                <li key={m.n} className="flex items-center justify-between gap-3 border-b border-dashed border-[#111]/30 pb-2 last:border-0 text-sm">
                  <span><b className="text-[#365CFF]">{m.n}</b> {m.title}</span><span className="text-xs font-bold">{m.mins}m</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
      <SyllabusModal open={open} onOpenChange={setOpen} returnFocusRef={btnRef} />
    </section>
  );
};
